export const cookieName = "i18next";
export const defaultNS = "global";
export const fallbackLng = "es";
export const languages = [fallbackLng, "en", "pt"];

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
